import { Outlet } from "react-router-dom";
import CommonLayout from "../../pages/Layouts/CommonLayout";
import useNewsCategory from "./useNewsCategory";

const NewsCategory = () => {
  const { drawerMenu } = useNewsCategory();

  return (
    <CommonLayout drawerMenu={drawerMenu}>
      <Outlet />
    </CommonLayout>
  );
};

export default NewsCategory;
